import { useColorMode, Image, useColorModeValue } from "@chakra-ui/react";
import lightSwitch from "../../assets/icons/light/toggle.svg";
import darkSwitch from "../../assets/icons/dark/toggle.svg";

export default function ThemeToggle({ ml }: any) {
  const { toggleColorMode } = useColorMode();
  const switchSrc = useColorModeValue(lightSwitch, darkSwitch);

  return (
    <Image
      src={switchSrc}
      cursor={"pointer"}
      h={{ base: "32px", lg: "52px" }}
      ml={ml}
      onClick={toggleColorMode}
      alt="icons"
    />
  );
}
